module.exports = __webpack_public_path__ + "static/img/下一张.620534e.png";